import { useEffect, useRef } from 'react'
import { io } from 'socket.io-client'

export function useImagecompoSocket(onChange) {
  const cbRef = useRef(onChange)
  useEffect(() => { cbRef.current = onChange }, [onChange])

  useEffect(() => {
    // Zelfde als vision: OBS-browser-source op /imagecompo/stage heeft geen
    // token, anonieme handshake toestaan.
    const token = localStorage.getItem('auth_token') || undefined
    const s = io({
      auth: { token },
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    })
    const subscribe = () => s.emit('imagecompo:subscribe')
    s.on('connect', subscribe)
    s.on('reconnect', subscribe)
    s.on('imagecompo:changed', (payload) => {
      try { cbRef.current?.(payload) } catch (e) { console.error('imagecompo:changed', e) }
    })
    return () => {
      try { s.emit('imagecompo:unsubscribe') } catch {}
      s.removeAllListeners()
      s.disconnect()
    }
  }, [])
}
